import { render, staticRenderFns } from "./MarketSite.vue?vue&type=template&id=e6071a8a&scoped=true&"
import script from "./MarketSite.vue?vue&type=script&lang=js&"
export * from "./MarketSite.vue?vue&type=script&lang=js&"
import style0 from "./MarketSite.vue?vue&type=style&index=0&id=e6071a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6071a8a",
  null
  
)

export default component.exports